import React from 'react';
import { 
  Box, Stack, VStack, Heading, Text, Button, Image, Icon, 
  Badge, Flex, useColorModeValue 
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FiZap, FiCheckCircle } from 'react-icons/fi';
import vg1 from "../../assets/images/coffeegrptch.png";

const CoffeeSection = () => {
  // Use the color variables you've already defined in your project
  const textMuted = useColorModeValue("gray.600", "gray.400");
  const headingColor = useColorModeValue("black", "white");
  const accentColor = "#F29201"; // Your signature yellow
  const primaryBlue = "#028EC4";

  return (
    <Box py={{ base: 16, md: 24 }} px={6} position="relative" overflow="hidden">
      {/* Background Decor */}
      <Box 
        position="absolute" 
        top="-10%" 
        right="-5%" 
        w="400px" 
        h="400px" 
        bg={useColorModeValue("yellow.50", "whiteAlpha.50")} 
        borderRadius="full" 
        filter="blur(80px)" 
        zIndex={-1}
      />

      <Stack
        direction={["column", "column", "row"]}
        align="center"
        justify="space-between"
        spacing={["12", "12", "20"]}
        maxW="7xl"
        mx="auto"
      >
        {/* LEFT IMAGE - Visual Flex */}
        <Box 
          flex="1" 
          display="flex" 
          justifyContent="center" 
          position="relative"
          role="group"
        >
          <Box
            position="absolute"
            inset="-10px"
            border="2px dashed"
            borderColor={accentColor}
            borderRadius="full"
            opacity={0.3}
            _groupHover={{ transform: "rotate(90deg)" }}
            transition="all 0.8s ease"
          />
          <Image
            src={vg1}
            alt="Coffee allowance illustration"
            boxSize={{ base: "300px", md: "450px" }}
            objectFit="contain"
            zIndex={1}
            filter="drop-shadow(0 20px 30px rgba(0,0,0,0.1))"
          />
        </Box>

        {/* RIGHT CONTENT - GenZ Energy */}
        <VStack
          flex="1.2"
          spacing={6}
          align={["center", "center", "flex-start"]}
          textAlign={["center", "center", "left"]}
        >
          <Badge 
            bg={useColorModeValue("yellow.100", "yellow.900")} 
            color={accentColor} 
            px={4} 
            py={1} 
            borderRadius="full"
            textTransform="none"
            fontSize="sm"
            fontWeight="bold"
          >
            <Icon as={FiZap} mr={1} /> No Gatekeeping Here
          </Badge>

          <Box>
            <Heading
              fontSize={["4xl", "5xl", "7xl"]}
              fontWeight="800"
              lineHeight="1"
              color={headingColor}
              fontFamily="Bricolage Grotesque"
              letterSpacing="tight"
            >
              The Coffee Allowance <br />
              
              <Text as="span" color={accentColor}>Hits Different.</Text>
            </Heading>
          </Box>

          <Text 
            fontSize={{ base: "lg", md: "xl" }} 
            fontWeight="600" 
            color={headingColor}
            lineHeight="shorter"
          >
            Because debugging at 2 AM requires liquid gold. ☕️
          </Text>

          <VStack align={["center", "center", "flex-start"]} spacing={4}>
            <Text
              fontSize="md"
              color={textMuted}
              maxW="550px"
              fontFamily="Poppins"
              lineHeight="tall"
            >
              At GrapplTech, we believe learning should be energizing—literally. 
              We’re fueling your grind with a zero-friction coffee allowance. 
              Whether you're ship-it-ready or just starting, we’ve got you.
            </Text>

            <Flex wrap="wrap" justify={["center", "center", "flex-start"]} gap={4}>
              {["Zero Eligibility Checks", "No Cap", "Instant Vibes"].map((feature) => (
                <Flex align="center" key={feature}>
                  <Icon as={FiCheckCircle} color={primaryBlue} mr={2} />
                  <Text fontWeight="600" fontSize="sm" color={headingColor}>{feature}</Text>
                </Flex>
              ))}
            </Flex>
          </VStack>

          {/* CTA BUTTON */}
          <Button
            as={Link}
            to="/bootcamps"
            size="lg"
            bg={primaryBlue}
            color="white"
            px={10}
            py={7}
            fontSize="lg"
            borderRadius="full"
            boxShadow="0 10px 20px -10px rgba(2, 142, 196, 0.5)"
            _hover={{ 
              bg: "#09537B",
              transform: "translateY(-2px)",
              boxShadow: "0 15px 30px -10px rgba(2, 142, 196, 0.6)"
            }}
            transition="all 0.3s"
          >
            Claim Your Vibe →
          </Button>
        </VStack>
      </Stack>
    </Box>
  );
};

export default CoffeeSection;